import _classCallCheck from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { Component, PropTypes } from 'react';
import styles from '../../build/styles';
import { getCallbacks } from '../helper/helper';

var Column =
/*#__PURE__*/
function (_Component) {
  _inherits(Column, _Component);

  function Column() {
    _classCallCheck(this, Column);

    return _possibleConstructorReturn(this, _getPrototypeOf(Column).apply(this, arguments));
  }

  _createClass(Column, [{
    key: "createClassName",
    value: function createClassName() {
      return [styles.column, styles[this.props.size], styles[this.props.offset], this.props.className].join(' ').trim();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement('div', _extends({}, getCallbacks(this.props), {
        className: this.createClassName(),
        style: this.props.style
      }), this.props.children);
    }
  }]);

  return Column;
}(Component);

export { Column as default };
Column.propTypes = {
  children: PropTypes.any,
  style: PropTypes.object,
  className: PropTypes.string,
  isMultiline: PropTypes.bool,
  size: PropTypes.oneOf(['is1', 'is2', 'is3', 'is4', 'is5', 'is6', 'is7', 'is8', 'is9', 'is10', 'is11', 'is12', 'isThreeQuarters', 'isTwoThirds', 'isHalf', 'isOneThird', 'isOneQuarter', 'isThreeQuartersMobile', 'isTwoThirdsMobile', 'isHalfMobile', 'isOneThirdMobile', 'isOneQuarterMobile', 'isThreeQuartersTablet', 'isTwoThirdsTablet', 'isHalfTablet', 'isOneThirdTablet', 'isOneQuarterTablet', 'isThreeQuartersDesktop', 'isTwoThirdsDesktop', 'isHalfDesktop', 'isOneThirdDesktop', 'isOneQuarterDesktop', 'isThreeQuartersWidescreen', 'isTwoThirdsWidescreen', 'isHalfWidescreen', 'isOneThirdWidescreen', 'isOneQuarterWidescreen', 'isNarrow', 'isNarrowMobile', 'isNarrowTablet', 'isNarrowDesktop', 'isNarrowWidescreen', 'isFull', 'isFullMobile', 'isFullTablet', 'isFullDesktop', 'isFullWidescreen']),
  offset: PropTypes.oneOf(['isOffsetThreeQuarters', 'isOffsetTwoThirds', 'isOffsetHalf', 'isOffsetOneThird', 'isOffsetOneQuarter', 'isOffset1', 'isOffset2', 'isOffset3', 'isOffset4', 'isOffset5', 'isOffset6', 'isOffset7', 'isOffset8', 'isOffset9', 'isOffset10', 'isOffset11', 'isOffset12', 'isOffset1Mobile', 'isOffset2Mobile', 'isOffset3Mobile', 'isOffset4Mobile', 'isOffset5Mobile', 'isOffset6Mobile', 'isOffset7Mobile', 'isOffset8Mobile', 'isOffset9Mobile', 'isOffset10Mobile', 'isOffset11Mobile', 'isOffset12Mobile', 'isOffset1Tablet', 'isOffset2Tablet', 'isOffset3Tablet', 'isOffset4Tablet', 'isOffset5Tablet', 'isOffset6Tablet', 'isOffset7Tablet', 'isOffset8Tablet', 'isOffset9Tablet', 'isOffset10Tablet', 'isOffset11Tablet', 'isOffset12Tablet', 'isOffset1Desktop', 'isOffset2Desktop', 'isOffset3Desktop', 'isOffset4Desktop', 'isOffset5Desktop', 'isOffset6Desktop', 'isOffset7Desktop', 'isOffset8Desktop', 'isOffset9Desktop', 'isOffset10Desktop', 'isOffset11Desktop', 'isOffset12Desktop', 'isOffset1Widescreen', 'isOffset2Widescreen', 'isOffset3Widescreen', 'isOffset4Widescreen', 'isOffset5Widescreen', 'isOffset6Widescreen', 'isOffset7Widescreen', 'isOffset8Widescreen', 'isOffset9Widescreen', 'isOffset10Widescreen', 'isOffset11Widescreen', 'isOffset12Widescreen'])
};